import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    justifyContent: "flex-end",
    flex: 1,
  },
  containerInput: {
    padding: 10,
    flexDirection: "row",
  },
  input: {
    backgroundColor: "lightgrey",
    borderRadius: 4,
    flex: 1,
    marginHorizontal: 10,
    paddingHorizontal: 10,
  },
});

export default styles;
